import React from 'react';
import { C } from '../constants';
import Section from './Section';
import SeriesRow from './SeriesRow';

export default function SearchResults({
  results, loading, query, genreFilter, yearFilter,
  library, seriesList, mediaInfo, history, ratings,
  isMobile, isTablet, isTV, cols,
  selected, hovered, setHovered,
  onCardClick, onSeriesClick,
  watchlist, toggleWatchlist,
}) {
  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '70px 0', color: C.textMuted }}>
        <div style={{ fontSize: '32px', marginBottom: '12px', animation: 'spin 1s linear infinite', display: 'inline-block' }}>◌</div>
        <p style={{ fontSize: '13px', fontFamily: 'Inter, sans-serif' }}>Buscando...</p>
        <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  if (!results) return null;

  // Cruzar resultados del servidor con datos locales (thumbnails, tipo, tamaño)
  const movies = (results.movies || [])
    .map(r => {
      const local = library.find(l => l.file === r.file);
      return local ? { ...local, ...r } : { file: r.file, name: r.name || r.title || r.file, type: 'movie', ...r };
    });

  const series = (results.series || [])
    .map(r => seriesList.find(s => s.id === r.id) || r);

  const total = movies.length + series.length;

  // Etiqueta de contexto
  const contextLabel = [
    query ? `"${query}"` : null,
    genreFilter || null,
    yearFilter ? `${yearFilter}` : null,
  ].filter(Boolean).join(' · ');

  if (total === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '80px 0', color: C.textDim }}>
        <p style={{ fontSize: '44px', marginBottom: '14px' }}>🔍</p>
        <p style={{ fontFamily: 'Playfair Display, serif', fontSize: '20px', color: C.textMuted, marginBottom: '8px' }}>Sin resultados</p>
        <p style={{ fontSize: '13px', fontFamily: 'Inter, sans-serif' }}>
          {contextLabel ? `No se encontró ${contextLabel}` : 'No hay contenido con esos filtros'}
        </p>
        <p style={{ fontSize: '12px', marginTop: '8px', color: C.textDim }}>
          Prueba con otro término o cambia los filtros
        </p>
      </div>
    );
  }

  return (
    <div>
      {/* Resumen de resultados */}
      <p style={{ color: C.textDim, fontSize: '12px', fontFamily: 'Inter, sans-serif', marginBottom: '16px' }}>
        <span style={{ color: C.accentSoft, fontWeight: '600' }}>{total}</span> resultado{total !== 1 ? 's' : ''}
        {contextLabel && <span> para <span style={{ color: C.accentSoft }}>{contextLabel}</span></span>}
      </p>

      {movies.length > 0 && (
        <Section
          title={series.length > 0 ? 'Películas' : ''}
          items={movies}
          history={history}
          ratings={ratings}
          mediaInfo={mediaInfo}
          selected={selected}
          hovered={hovered}
          setHovered={setHovered}
          isMobile={isMobile}
          isTablet={isTablet}
          isTV={isTV}
          cols={cols}
          onCardClick={onCardClick}
          watchlist={watchlist}
          toggleWatchlist={toggleWatchlist}
        />
      )}

      {series.length > 0 && (
        <SeriesRow
          seriesList={series}
          isMobile={isMobile}
          isTV={isTV}
          onSeriesClick={onSeriesClick}
          watchlist={watchlist}
          toggleWatchlist={toggleWatchlist}
        />
      )}
    </div>
  );
}
